import { EntryComponent, Series } from '@cambridgeassessment/lib-ee-commons';
import {
  PlagiarismAssessment,
  ProcessingError,
  ReportDetails,
  ReportDetailsParams,
  ReportSummary,
  SearchQuery,
} from '../../types/Plagiarism';

export const GET_SERIES = '@PLAGIARISM/GET_SERIES';
export const SET_SERIES = '@PLAGIARISM/SET_SERIES';
export const GET_ASSESSMENTS = '@PLAGIARISM/GET_ASSESSMENTS';
export const SET_ASSESSMENTS = '@PLAGIARISM/SET_ASSESSMENTS';
export const GET_ASSESSMENT_COMPONENTS = '@PLAGIARISM/GET_ASSESSMENT_COMPONENTS';
export const SET_ASSESSMENT_COMPONENTS = '@PLAGIARISM/SET_ASSESSMENT_COMPONENTS';
export const SET_REPORT_SUMMARY = '@PLAGIARISM/SET_REPORT_SUMMARY';
export const SET_PROCESSING_ERRORS_LIST = '@PLAGIARISM/SET_PROCESSING_ERRORS_LIST';
export const SET_SEARCH_QUERY = '@PLAGIARISM/SET_SEARCH_QUERY';
export const RESET_STATE = '@PLAGIARISM/RESET_STATE';
export const SET_REPORT_DETAILS = '@PLAGIARISM/SET_REPORT_DETAILS';
export const SET_REPORT_DETAILS_PARAMS = '@PLAGIARISM/SET_REPORT_DETAILS_PARAMS';

export interface GetSeries {
  type: typeof GET_SERIES;
}

export interface SetSeries {
  type: typeof SET_SERIES;

  payload: {
    seriesData: Series[];
  };
}

export interface GetAssessments {
  type: typeof GET_ASSESSMENTS;
}

export interface SetAssessments {
  type: typeof SET_ASSESSMENTS;

  payload: {
    assessments: PlagiarismAssessment[];
  };
}

export interface GetAssessmentComponents {
  type: typeof GET_ASSESSMENT_COMPONENTS;
}

export interface SetAssessmentComponents {
  type: typeof SET_ASSESSMENT_COMPONENTS;

  payload: {
    components: EntryComponent[];
  };
}

export interface SetReportSummary {
  type: typeof SET_REPORT_SUMMARY;

  payload: {
    reportSummary: ReportSummary[];
    nextPageUrl?: string;
    reportsTotal: number;
  };
}

export interface SetSearchQuery {
  type: typeof SET_SEARCH_QUERY;

  payload: {
    searchQuery: SearchQuery;
  };
}

export interface ResetState {
  type: typeof RESET_STATE;
}

export interface SetReportDetails {
  type: typeof SET_REPORT_DETAILS;

  payload: {
    reportDetails: ReportDetails[];
    nextPageUrl?: string;
    reportsDetailsTotal: number;
  };
}

export interface SetReportDetailsParams {
  type: typeof SET_REPORT_DETAILS_PARAMS;

  payload: { reportDetailsParams: ReportDetailsParams };
}

export interface SetProcessingErrorsList {
  type: typeof SET_PROCESSING_ERRORS_LIST;
  payload: {
    items: ProcessingError[];
    nextPageUrl?: string;
  };
}

export type PlagiarismActionTypes =
  | GetSeries
  | SetSeries
  | GetAssessments
  | SetAssessments
  | GetAssessmentComponents
  | SetAssessmentComponents
  | SetReportSummary
  | SetSearchQuery
  | ResetState
  | SetReportDetails
  | SetReportDetailsParams
  | SetProcessingErrorsList;
